export const isArrayExits = (lists, id) => {
  return lists.some((list) => list?._id === id);
};
